import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';

function TextInput({
  type,
  name,
  placeholder,
  value,
  disabled,
  onChange,
  error,
  as,
  autoComplete,
}) {
  return (
    <FloatingLabel
      className="mb-3"
      controlId={`floating-${name}`}
      label={placeholder}
    >
      <Form.Control
        disabled={disabled}
        type={type}
        placeholder={placeholder}
        isInvalid={error}
        value={value}
        onChange={onChange}
        as={as}
        autoComplete={autoComplete}
      />
      {error && (
        <Form.Control.Feedback type="invalid">{error}</Form.Control.Feedback>
      )}
    </FloatingLabel>
  );
}

TextInput.defaultProps = {
  disabled: false,
  as: 'input',
  type: 'text',
};

export default TextInput;
